import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {IDialogComponent} from "../../../../../dialog/iDialog.component";
import {DialogWithInput} from "../../../../../dialog/dialogWithInput";
import {CommonModule} from "@angular/common";
import {DialogModule} from "../../../../../dialog/dialog.module";
import {TablerIconsModule} from "angular-tabler-icons";
import {MatTooltipModule} from "@angular/material/tooltip";
import {ErrorCardModule} from "../../../../../../../components/common/error-card/error-card.module";
import {FormFieldModule} from "../../../../../../core/component/form-field/form-field.module";

@Component({
  templateUrl: './audio-recording-settings-dialog.component.html',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    TablerIconsModule,
    MatTooltipModule,
    ErrorCardModule,
    FormFieldModule,
  ]
})
export class AudioRecordingSettingsDialogComponent
    implements OnInit, IDialogComponent<void, void>, OnDestroy {

  dialog: DialogWithInput<void, void>;

  @ViewChild('audioPlayer', { static: false }) audioPlayerRef!: ElementRef<HTMLAudioElement>;


  noAccessToMicro = false;
  audioContext: AudioContext | null = null;
  analyser: AnalyserNode | null = null;
  mediaStream: MediaStream | null = null;
  mediaRecorder: MediaRecorder | null = null;
  audioChunks: Blob[] = [];
  audioURL: string | null = null;
  recording: boolean = false;
  activeMicrophoneName: string | null = null;
  recordingTimeout: any;


  ngOnInit(): void {
    this.initMicrophone();
  }

  async initMicrophone() {
    try {
      // Demande d'accès au microphone pour récupérer le nom du microphone actif
      this.mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });

      // Récupérer le nom du microphone actif
      await this.getActiveMicrophoneName();

      // Configuration de MediaRecorder mais sans démarrer l'enregistrement
      this.setupRecorder();
    } catch (error) {
      this.noAccessToMicro = true;
      console.error('Erreur lors de l’accès au microphone :', error);
    }
  }

  setupRecorder() {
    if (!this.mediaStream) return;

    // Configuration de MediaRecorder pour enregistrer le flux audio
    this.mediaRecorder = new MediaRecorder(this.mediaStream);
    this.mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        this.audioChunks.push(event.data);
      }
    };

    this.mediaRecorder.onstop = () => {
      // Créer un URL Blob pour le fichier audio
      const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
      this.audioURL = URL.createObjectURL(audioBlob);
      this.audioChunks = []; // Réinitialiser les données pour un nouvel enregistrement
      this.playAudio();
    };
  }

  startRecording() {
    if (!this.mediaRecorder) return;

    this.audioChunks = []; // Vider les anciens morceaux audio
    this.mediaRecorder.start();
    this.recording = true;
    this.recordingTimeout = setTimeout(() => {
      this.stopRecording();
    }, 10000); // 10000 ms = 10 secondes
  }

  stopRecording() {
    if (!this.mediaRecorder || !this.recording) return;

    this.mediaRecorder.stop();
    this.recording = false;
    clearTimeout(this.recordingTimeout);
  }

  async getActiveMicrophoneName() {
    if (!this.mediaStream) return;

    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const audioDevice = devices.find(device =>
          device.kind === 'audioinput' &&
          this.mediaStream?.getAudioTracks()[0].getSettings().deviceId === device.deviceId
      );

      this.activeMicrophoneName = audioDevice ? audioDevice.label : 'Microphone inconnu';
      console.log("Microphone actif:", this.activeMicrophoneName);
    } catch (error) {
      console.error("Erreur lors de la récupération des appareils :", error);
    }
  }

  playAudio() {
    console.log(["Play Audio", this.audioURL, this.audioPlayerRef]);
    if (this.audioPlayerRef && this.audioURL) {
      const audioElement = this.audioPlayerRef.nativeElement;
      audioElement.src = this.audioURL; // Définir l'URL audio
      audioElement.load(); // Charger l'élément audio
      audioElement.play(); // Démarrer la lecture
    }
  }

  ngOnDestroy(): void {
    if (this.audioContext) {
      this.audioContext.close();
    }
    if (this.mediaStream) {
      this.mediaStream.getTracks().forEach(track => track.stop());
    }
    clearTimeout(this.recordingTimeout);
  }
}
